import { createContext, useContext } from 'react';
const invariantViolation = () => {
    throw new Error('Attempted to call useModal outside of modal context. Make sure your app is rendered inside ModalProvider.');
};
export const GlobalModalContext = createContext({
    dispatch: invariantViolation
});
export function useGlobalModalContext() {
    return useContext(GlobalModalContext);
}
export function reducer(state, action) {
    const { payload, type } = action;
    const id = payload.RenderModal.name;
    switch (type) {
        case 'openModal':
            return {
                ...state,
                [id]: {
                    isOpen: true,
                    props: payload.props || {},
                    RenderModal: payload.RenderModal
                }
            };
        case 'closeModal': {
            const { [id]: key, ...nextState } = state;
            return key ? nextState : state;
        }
    }
}
//# sourceMappingURL=GlobalModalContext.js.map